import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute } from '@angular/router';
import { CounsellorPublicProfileVM } from '../../../models';
import { Location } from '@angular/common';

@Component({
  selector: 'pro-profile',
  templateUrl: './pro-profile.component.html'
})
export class ProProfileComponent extends BaseComponent implements OnInit {

  profileModel: CounsellorPublicProfileVM = new CounsellorPublicProfileVM();

  constructor(
    private route: ActivatedRoute,
    private _location: Location
  ) {
    super(route);
  }

  ngOnInit(): void {
    if (this.route.snapshot.data['profile']) {
      this.profileModel = this.route.snapshot.data['profile'];
    }
  }

  back() {
    this._location.back();
  }

}

